module.exports = __webpack_public_path__ + "h5/img/myvip.1abdfef9.jpg";